import styled from "styled-components";
import { BasicTitle } from "../../../styles/styled-components/basic";

const NoMatchTitle = styled(BasicTitle)`
  margin-bottom: 15px;
`;

export { NoMatchTitle };
